import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { userColumnsConfig } from "../config/Users";

import { getUserWithFilter, updateUserStatus } from "../../../slices/thunks";
import { ConfirmPopup } from "../Confirmation";

export const getUserColumns = ({ onDeleteClick }) => {
  const [confirmOpenForId, setConfirmOpenForId] = useState(null);
  const dispatch = useDispatch();

  return [
    {
      name: <span className="font-weight-bold fs-13">{userColumnsConfig.NAME}</span>,
      selector: (row) => row.displayName,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{userColumnsConfig.EMAIL}</span>,
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{userColumnsConfig.GENDER}</span>,
      selector: (row) => row.gender.charAt(0).toUpperCase() + row.gender.slice(1),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{userColumnsConfig.SOCIAL_TYPE}</span>,
      selector: (row) => row.socialType.charAt(0).toUpperCase() + row.socialType.slice(1),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{userColumnsConfig.STATUS}</span>,
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            id={`status-switch-${row.id}`}
            checked={row.status === "active"}
            onChange={() => {
              const newStatus = row.status === "active" ? "inactive" : "active";

              dispatch(updateUserStatus({ status: newStatus, id: row.id }))
                .unwrap()
                .then(() => {
                  dispatch(getUserWithFilter({})); // Fetch updated user list
                })
                .catch((error) => {
                  console.error("Error updating status:", error);
                });
            }}
          />
          <label className="form-check-label" htmlFor={`status-switch-${row.id}`}>
            {row.status === "active" ? "Active" : "Inactive"}
          </label>
        </div>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">{userColumnsConfig.ACTIONS}</span>,
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-center">
          <a
            href="#"
            onClick={(event) => {
              event.preventDefault();
              setConfirmOpenForId(row.id);
            }}
            className="p-2 fs-13 nav-link refresh-button"
          >
            <i className="ri-delete-bin-7-fill fs-13 p-2 bg-soft-danger text-red rounded-circle align-middle"></i>
          </a>
          {confirmOpenForId === row.id && (
            <ConfirmPopup
              message={userColumnsConfig.messages}
              setConfirmOpen={() => setConfirmOpenForId(null)}
              onConfirm={(event) => {
                onDeleteClick(event, row.id);
                setConfirmOpenForId(null);
              }}
            />
          )}
        </div>
      ),
    },
  ];
};
